import { Controller, useFieldArray } from 'react-hook-form';

import { EActionAttribute, EColor, EIcon, ESize, ETypographyVariant } from '@core/type';

import { ButtonIcon } from '../../button';
import { Box } from '../../layout';
import { Link } from '../../link';
import { SelectText } from '../../select';
import { SelectMultipleControlProps } from './interface-form-select';

export const SelectMultipleControl = ({
  name,
  control,
  title,
  addText,
  children,
  options,
  watch,
  isSubmitted,
  errors,
  trigger,
  isPhone,
  ...inputProps
}: SelectMultipleControlProps) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name,
  });

  return (
    <Box>
      <Box marginBottom={'30px'} position={'relative'}>
        {title}
      </Box>
      <Box display="flex" gap="16px" flexDirection="column" marginBottom={'24px'}>
        {fields.map((item, index) => (
          <Box key={item.id} display="flex" width={'100%'}>
            <Controller
              name={`${name}.${index}.value`}
              control={control}
              render={({ field, fieldState }) => (
                <SelectText
                  field={field}
                  {...inputProps}
                  options={options?.filter(
                    (option) =>
                      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
                      !watch(name)
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                        ?.filter(
                          (el: { value: string }) => el.value !== watch(`${name}.${index}.value`),
                        )
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                        .map((el: { value: string }) => el.value)
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                        .includes(option.value),
                  )}
                  fieldState={{
                    ...fieldState,
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
                    error: errors?.[name]?.[index]?.value,
                  }}
                  isSubmitted={isSubmitted}
                  onChange={(e) => {
                    // eslint-disable-next-line @typescript-eslint/no-floating-promises
                    trigger && void trigger();
                    field.onChange(e);
                  }}
                />
              )}
            />
            {index !== 0 && (
              <ButtonIcon
                type={'button'}
                onClick={() => {
                  remove(index);
                }}
                padding="0 24px"
                iconProps={{ type: EIcon.BIN, size: ESize.MD, color: EColor.PRIMARY }}
                hoverFill={EColor.DANGER}
                whiteSpace="nowrap"
              />
            )}
          </Box>
        ))}
      </Box>
      {children}
      <Box marginTop={isPhone ? '24px' : '8px'}>
        <Link
          as={EActionAttribute.BUTTON}
          buttonType={'button'}
          startIcon={EIcon.CIRCLE_PLUS}
          iconSize={ESize.XXS}
          onClick={() => {
            append({ value: '' });
          }}
          variant={ETypographyVariant.BODY3}
        >
          {addText}
        </Link>
      </Box>
    </Box>
  );
};

SelectMultipleControl.displayName = 'SelectMultipleControl';
